"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfUpdateDigestTimesDto = instanceOfUpdateDigestTimesDto;
exports.UpdateDigestTimesDtoFromJSON = UpdateDigestTimesDtoFromJSON;
exports.UpdateDigestTimesDtoFromJSONTyped = UpdateDigestTimesDtoFromJSONTyped;
exports.UpdateDigestTimesDtoToJSON = UpdateDigestTimesDtoToJSON;
exports.UpdateDigestTimesDtoToJSONTyped = UpdateDigestTimesDtoToJSONTyped;
/**
 * Check if a given object implements the UpdateDigestTimesDto interface.
 */
function instanceOfUpdateDigestTimesDto(value) {
    if (!('primaryId' in value) || value['primaryId'] === undefined)
        return false;
    return true;
}
function UpdateDigestTimesDtoFromJSON(json) {
    return UpdateDigestTimesDtoFromJSONTyped(json, false);
}
function UpdateDigestTimesDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'primaryId': json['primaryId'],
        'eveningId': json['eveningId'] == null ? undefined : json['eveningId'],
    };
}
function UpdateDigestTimesDtoToJSON(json) {
    return UpdateDigestTimesDtoToJSONTyped(json, false);
}
function UpdateDigestTimesDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'primaryId': value['primaryId'],
        'eveningId': value['eveningId'],
    };
}
